var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "radio-status" }, [
    _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
    _c("div", { staticClass: "sub-title" }, [_vm._v(_vm._s(_vm.subTitle))]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }